import { Injectable, signal } from '@angular/core';

import { CurrentOrg } from '@efficiently/client-api-org-context';

/**
 * Default {@link CurrentOrg} implementation backed by a writable signal.
 *
 * Producers (hostname bootstrap in client-portal, `AppInitService` in
 * design-schedule) call {@link setOrgId} from inside an awaited app initializer
 * — Angular finishes bootstrap only after those initializers resolve, so any
 * downstream consumer reads a fully-populated value.
 */
@Injectable({ providedIn: 'root' })
export class DefaultCurrentOrg extends CurrentOrg {
	private readonly _orgId = signal<string | undefined>(undefined);

	public readonly orgId = this._orgId.asReadonly();

	public override setOrgId(orgId: string | undefined): void {
		this._orgId.set(orgId);
	}
}
